import { urlBuilder } from '../../../Shared/urlBuilder';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';
import { NavLink } from '../nav-link/NavLink';

export const HomeLink = () => {
  const processNavTransition = useProcessNavTransition();

  return (
    <NavLink to={urlBuilder.appHome()} onClick={processNavTransition}>
      <NavLink.Icon name="Home" />
      <NavLink.Text>Home</NavLink.Text>
    </NavLink>
  );
};
